
namespace GeniuzPOS.Points {

    @Serenity.Decorators.registerClass()
    export class PrPointRedeemItemGrid extends Serenity.EntityGrid<PrPointRedeemItemRow, any> {
        protected getColumnsKey() { return PrPointRedeemItemColumns.columnsKey; }
        protected getDialogType() { return PrPointRedeemItemDialog; }
        protected getIdProperty() { return PrPointRedeemItemRow.idProperty; }
        protected getInsertPermission() { return PrPointRedeemItemRow.insertPermission; }
        protected getLocalTextPrefix() { return PrPointRedeemItemRow.localTextPrefix; }
        protected getService() { return PrPointRedeemItemService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}